import { PLAYER_CONTROLS } from '@unicons-types/player.types';

export const handleControls = (control: PLAYER_CONTROLS, player: any) => {
  if (player) {
    const minimumVolume = 0.1;
    const currentVolume = parseFloat(player.volume().toFixed(1));
    const currentTime = player.currentTime();
    switch (control) {
      case PLAYER_CONTROLS.PLAY_PAUSE:
        if (player.paused()) {
          player.play();
        } else {
          player.pause();
        }
        break;
      case PLAYER_CONTROLS.PLAY:
        player.play();
        break;
      case PLAYER_CONTROLS.PAUSE:
        player.pause();
        break;
      case PLAYER_CONTROLS.MUTE:
        if (player.muted()) {
          player.trigger('mute');
        } else {
          player.trigger('unmute');
        }
        break;
      case PLAYER_CONTROLS.FULLSCREEN:
        if (player.isFullscreen()) {
          player.exitFullscreen();
          player.trigger('exitFullscreen');
        } else {
          player.requestFullscreen();
          player.trigger('enterFullscreen');
        }
        break;
      case PLAYER_CONTROLS.TRIGGER_FULLSCREEN:
        if (player.isFullscreen()) {
          player.trigger('exitFullscreen');
        } else {
          player.trigger('enterFullscreen');
        }
        break;
      case PLAYER_CONTROLS.FORWARD_10:
        player.currentTime(currentTime + 10);
        break;
      case PLAYER_CONTROLS.BACK_10:
        player.currentTime(currentTime - 10);
        break;
      case PLAYER_CONTROLS.VOLUME_UP:
        if (currentVolume < 1) {
          player.volume(currentVolume + minimumVolume);
          player.trigger('volumeUp');
        }
        break;
      case PLAYER_CONTROLS.VOLUME_DOWN:
        if (currentVolume > 0) {
          player.volume(currentVolume - minimumVolume);
          player.trigger('volumeDown');
        } else {
          player.trigger('mute');
        }
        break;
      default:
        player.play();
    }
  }
};

export const handlePlayerReady = () => {
  // Move logic from lesson Player to here
};

// Convert seconds to HH:mm:ss
export const getTime = (seconds: number = 0, onlyMinutes = false) => {
  if (seconds < 3600) {
    // show mm:ss format
    if (onlyMinutes)
      return new Date(seconds * 1000).toISOString().substr(14, 5).split(':')[0];
    return new Date(seconds * 1000).toISOString().substr(14, 5);
  }
  // show HH:mm:ss format
  return new Date(seconds * 1000).toISOString().substr(11, 8);
};

// Convert HH:mm:ss to seconds
export const getSeconds = (time: string) => {
  const splitTime = time.split(':');
  const seconds =
    parseInt(splitTime[0], 10) * 60 * 60 +
    parseInt(splitTime[1], 10) * 60 +
    parseInt(splitTime[2], 10);
  return seconds;
};

export const getControlIcon = (control: PLAYER_CONTROLS) => {
  if (control === PLAYER_CONTROLS.PLAY) return 'play.svg';
  if (control === PLAYER_CONTROLS.PAUSE) return 'pause-video.svg';
  if (control === PLAYER_CONTROLS.FORWARD_10) return 'forward-video.svg';
  if (control === PLAYER_CONTROLS.BACK_10) return 'rewind-video.svg';
  if (control === PLAYER_CONTROLS.MUTE) return 'mute.svg';
  if (control === PLAYER_CONTROLS.VOLUME_DOWN) return 'volume-low.svg';
  if (control === PLAYER_CONTROLS.VOLUME_UP) return 'volume-high.svg';

  return 'pause.svg';
};

function getOrdinalNum(n) {
  return (
    n +
    (n > 0
      ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10]
      : '')
  );
}

export const getPublishDay = (utcDate) => {
  const options = {
    month: 'short'
  } as any;
  const date = new Date(utcDate);
  const day = new Date(utcDate).getUTCDate();
  const month = date.toLocaleDateString('en-US', options);

  return `${getOrdinalNum(day)} ${month}`;
};
